export enum ViewColumnBehaviour {
  Default = 0,
  Clickable = 10,
}

export enum ViewColumnDetail {
  Default = 0,
  Extra = 10,
}

export enum ViewColumnAlignment {
  Left = 0,
  Right = 10,
  Center = 20,
}
